import { Component, computed, input, output } from '@angular/core'

import type { UserDto } from '../../../../api/responses'

@Component({
  selector: 'dhp-profile-icon',
  templateUrl: './profile-icon.component.html',
  styleUrl: './profile-icon.component.scss',
  imports: [],
})
export class ProfileIconComponent {
  user = input<UserDto | null | undefined>()
  protected userInitials = computed(() => this.generateInitials(this.user()))
  iconClicked = output<MouseEvent>()

  private generateInitials(user: UserDto | null | undefined): string | null {
    if (!user) {
      return null
    }

    if (user.name) {
      return user.name.charAt(0)
    }

    return [user.first_name, user.last_name]
      .filter(Boolean)
      .map(name => name!.charAt(0))
      .join('')
  }
}
